<template>
    <div>
        <card-header title="Edit Conference" icon="fa-pencil" />

        <card-body>
            <conference-form :conference="conference" />
        </card-body>

        <card-footer class="pt-3 pb-3">
            <div class="columns">
                <div class="column">
                    <b-button type="is-warning is-outlined" size="is-small" @click="deleteConf"><i class="far fa-trash-alt"></i><span class="ml-2" v-if="confirmDelete">Delete Conference?</span></b-button>
                </div>
                <div class="column has-text-right">
                    <b-button
                        type="is-primary"
                        size="is-small"
                        @click="submit"
                        :disabled="!conference.title || !conference.code || !conference.start || !conference.end"
                    ><i class="fas fa-check mr-2"></i>Save Conference
                    </b-button>
                </div>
            </div>
        </card-footer>
    </div>
</template>

<script>
    import CardHeader from "@/TIER/components/CardHeader";
    import CardBody from "@/TIER/components/CardBody";
    import CardToolbar from "@/TIER/components/CardToolbar";
    import CardFooter from "@/TIER/components/CardFooter";
    import ConferenceForm from "@/cards/conferences/ConferenceForm";

    import {client as http} from '@/http_client';
    import moment from "moment";

    import async from 'async';
    import {mapGetters} from "vuex";

    export default {
        components: {ConferenceForm, CardFooter, CardToolbar, CardBody, CardHeader},
        props: ['card', 'props'],
        data() {
            return {
                conference: {},
                confirmDelete: false,
                dirty: null
            };
        },
        computed: {
            ...mapGetters(['currentUser'])
        },
        methods: {
            loadConference: function () {
                this.$emit('loading', true);
                async.series([
                    (cb) => {
                        http.get('conferences/' + this.props.confId, {force: true}).then(response => {
                            response.data.contentProviders = null;
                            this.conference = response.data;
                            this.conference.start = (response.data.start_at) ? moment(response.data.start_at).toDate() : null;
                            this.conference.end = (response.data.end_at) ? moment(response.data.end_at).toDate() : null;
                            this.conference.open = (response.data.open_at) ? moment(response.data.open_at).toDate() : null;
                            this.conference.close = (response.data.close_at) ? moment(response.data.close_at).toDate() : null;
                            cb();
                        }).catch(err => {
                            cb(err);
                        });
                    },
                    (cb) => {
                        if (this.currentUser.isSuper || !this.currentUser.isContentProvider) {
                            http.get('content-providers', {force: true}).then(response => {
                                this.conference.contentProviders = response.data;
                                cb();
                            }).catch(err => {
                                cb(err);
                            });
                        } else {
                            cb();
                        }
                    }
                ], (err) => {
                    if (err) {
                        window.alert('An error occurred while loading the conference.');
                    }
                    this.$emit('loading', false);
                });

            },
            submit: function () {
                http.put('conferences/' + this.props.confId, {
                    title: this.conference.title,
                    code: this.conference.code,
                    location: this.conference.location,
                    start: this.conference.start,
                    end: this.conference.end,
                    open: this.conference.open,
                    close: this.conference.close,
                    logo: this.conference.logo,
                    description: this.conference.description,
                    information: this.conference.information,
                    email_information: this.conference.email_information,
                    support_email: this.conference.support_email,
                    support_phone: this.conference.support_phone,
                    wa_edu: this.conference.wa_edu,
                    is_allow_cc: this.conference.is_allow_cc,
                    is_allow_po: this.conference.is_allow_po,
                    is_allow_invoice: this.conference.is_allow_invoice,
                    po_mail_to: this.conference.po_mail_to,
                    po_attn_to: this.conference.po_attn_to,
                    po_address_1: this.conference.po_address_1,
                    po_address_2: this.conference.po_address_2,
                    po_city: this.conference.po_city,
                    po_state: this.conference.po_state,
                    po_zip: this.conference.po_zip,
                    po_email: this.conference.po_email,
                    po_instructions: this.conference.po_instructions,
                    registration_cap: this.conference.registration_cap,
                    syllabus: this.conference.syllabus,
                    goals: this.conference.goals,
                    objectives: this.conference.objectives,
                    outcomes: this.conference.outcomes,
                    standards: this.conference.standards,
                    instructor: this.conference.instructor,
                    resume: this.conference.resume,
                    num_participants: this.conference.num_participants,
                    is_active: this.conference.is_active,
                    is_highlighted: this.conference.is_highlighted,
                    default_cc_surcharge: this.conference.default_cc_surcharge,
                    default_cc_surcharge_info: this.conference.default_cc_surcharge_info,
                    default_cc_fee: this.conference.default_cc_fee,
                    default_po_fee: this.conference.default_po_fee,
                    default_org_share: this.conference.default_org_share,
                    default_self_share: this.conference.default_self_share,
                    content_provider_id: this.conference.content_provider_id
                }, {force: true}).then(response => {
                    this.$reloadCard('conferences');
                    this.$reloadCard('conference', {confId: this.props.confId});
                    this.$saveAlert(false);
                    this.$closeCard(this.card);
                }).catch(err => {
                    window.alert('An error occurred while saving the conference.');
                    this.$emit('loading', false);
                });
            },
            deleteConf() {
                if (this.confirmDelete) {
                    this.$emit('loading', true);

                    http.delete('conferences/' + this.props.confId).then(response => {
                        this.$reloadCard('conferences');
                        this.$reloadCard('conference', {confId: this.props.confId});
                        this.$saveAlert(false);
                        this.$closeCard(this.card);
                    }).catch(err => {

                    });
                } else {
                    this.confirmDelete = true;
                    setTimeout(() => {
                        this.confirmDelete = false;
                    }, 3000);
                }
            }
        },
        watch: {
            'props.confId': function () {
                this.dirty = null;
                this.loadConference();
            },
            'conference': {
                deep: true,
                handler: function () {
                    this.dirty = (this.dirty !== null);
                    if (!this.$TIER.saveAlert.active && this.dirty)
                        this.$saveAlert(true, 'Are you done editing this conference? Unsaved changes will be lost.');
                }
            }
        },
        mounted() {
            this.loadConference();
        }
    };
</script>
